import { observer } from '@formily/reactive-vue';
import { Message } from 'element-ui';
import { connect, mapProps, mapReadPretty, h, useField, useForm } from '@formily/vue';
import { defineComponent, ref, watch } from '@vue/composition-api';
import { Uploader as VanUploader, Toast, ImagePreview } from 'vant';
import { PreviewText } from '@formily/vant';
import 'vant/lib/uploader/index.less';
import '@formily/vant/esm/preview-text/style';
import request from 'axios';
import store from '@/store';
import Vue from 'vue';
import { getWeWorkAppJsapiTicket, callAiAgentPhotoCheck } from '@/api/person/personApi';
import { ocrImage } from '@/api/agent/agentApi';
import NewUpload from './newUpload.vue';
import { previewFileInPopup } from './filePreviewPopup';

// const TransformVanUploader = transformComponent(VanUploader, {
//   change: 'input',
// });

// 需要被替换的 action URL 列表
const uploadActionAliases = [
  'https://dcops.test.tencent.com/file-center/tus/relay/cosfile',
  'https://dcops.idc.tencent.com/file-center/tus/relay/cosfile',
];
const uploadActionTarget = '/relay/cosfile/index';

// 判断并替换 action
const normalizeAction = (action) => {
  if (!action) return action;
  if (uploadActionAliases.includes(action)) {
    return uploadActionTarget;
  }
  return action;
};

const BaseUploader = observer(
  defineComponent({
    name: 'FBaseUploader',
    props: ['value', 'action'],
    setup(props, { attrs, slots, listeners, emit }) {
      const field = useField();
      const form = useForm();

      const mobileSmall = field.value.componentProps.mobileSmall || false;
      // 设置 accept 属性，控制文件选择器显示的文件类型
      // 注意: 不同设备/浏览器对 accept 的处理差异很大
      if (field.value.componentProps.photoAlbumDisabled) {
        // 仅允许图片
        attrs.accept = 'image/*';
      } else {
        // 允许所有文件类型
        // 方案1: 使用 */* 表示所有类型（部分设备可能不支持）
        // 方案2: 明确列出常见文件类型（兼容性更好）
        // 方案3: 完全不设置（让浏览器决定，但可能默认只显示图片）
        // 
        // 这里使用方案2: 明确列出常见类型 + 通配符，兼容性最好
        // 注意: iOS 对 accept 的支持有限，可能仍然只显示图片/视频
        attrs.accept = [
          'image/*',                    // 所有图片
          'video/*',                    // 所有视频
          'audio/*',                    // 所有音频
          'application/pdf',            // PDF
          'application/msword',         // DOC
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
          'application/vnd.ms-excel',   // XLS
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
          'application/vnd.ms-powerpoint', // PPT
          'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX
          'application/zip',            // ZIP
          'application/x-rar-compressed', // RAR
          'text/plain',                 // TXT
          '*/*'                         // 兜底：所有类型
        ].join(',');
      }
      const isOpenUpload = store.getters.getConfigItem('isOpenUpload');

      // newChooseImage 支持四个选项：
      // 'none' - 只显示浏览器原生上传（默认）
      // 'both' - 显示所有三个选项（浏览器上传 + 微信拍照/选图 + 从会话选择文件）
      // 'chat' - 显示两个选项（浏览器上传 + 从会话选择文件）
      // 'wework' - 显示两个选项（浏览器上传 + 微信拍照/选图）
      // 注意：浏览器上传选项始终存在，企微相关选项根据配置显示
      // 兼容处理：如果传入的是布尔值，true 相当于 'both'，false 相当于 'none'
      let newChooseImage = field.value.componentProps?.newChooseImage;
      // 处理默认值（仅在值为 null 或 undefined 时使用默认值）
      if (newChooseImage === null || newChooseImage === undefined) {
        newChooseImage = 'none';
      }
      // 兼容布尔类型
      if (typeof newChooseImage === 'boolean') {
        newChooseImage = newChooseImage ? 'both' : 'none';
      }
      console.log(newChooseImage,"newChooseImage");
      

      // ==================================================================================
      // 🔴🔴🔴 newChooseImage 不为 'none' 时的微信环境检测 🔴🔴🔴
      // 🔵🔵🔵 newChooseImage = 'none' 时，虽然会执行，但不影响逻辑 🔵🔵🔵
      // ==================================================================================

      // 检查是否在微信/企微环境中
      const isWechatEnv = (() => {
        if (typeof window === 'undefined') {
          return false;
        }
        // 检查 User Agent 是否包含微信/企微标识
        const ua = window.navigator.userAgent.toLowerCase();
        const isWxUA = ua.includes('micromessenger') || ua.includes('wxwork');

        // 优先判断 UA,因为企微环境下 ww 对象可能延迟加载
        // 只要 UA 符合,就认为是微信环境(JS-SDK 会在后续配置时加载)
        return isWxUA;
      })();

      // ==================================================================================
      // 🔴🔴🔴 以下是微信 SDK 配置相关代码（仅 newChooseImage 不为 'none' 时使用）🔴🔴🔴
      // ==================================================================================

      // 微信 SDK 是否已配置的标记（使用普通变量）
      let wxConfigured = false;
      let agentConfigured = false; // agentConfig 是否已配置成功
      let configPromise = null; // 保存配置的 Promise，避免重复配置

      // 配置微信 JS-SDK（只配置一次）
      const ensureWechatConfig = async () => {
        // ==================================================================================
        // 🧪🧪🧪 额外验证代码（已注释）：用于测试 signatureApi 鉴权能力
        // ==================================================================================
        // setTimeout(() => {
        //   (async () => {
        //     try {
        //       const signatureApiUrl = store.getters.getConfigItem('signatureApi');
        //       console.log('🧪🧪🧪 [强制验证] 开始执行，signatureApiUrl =', signatureApiUrl);
        //
        //       if (!signatureApiUrl) {
        //         console.warn('🧪🧪🧪 [强制验证] signatureApi 未配置，跳过验证');
        //         return;
        //       }
        //
        //       const verifyTimestamp = `${Math.round(new Date() / 1000)}`;
        //       const verifyData = {
        //         Url: window.location.href,
        //         Noncestr: 'otob',
        //         Timestamp: verifyTimestamp,
        //       };
        //
        //       console.log('🧪🧪🧪 [强制验证] 签名参数:', verifyData);
        //
        //       const verifyRes = await request.post(signatureApiUrl, verifyData, {
        //         headers: {
        //           authToken: sessionStorage.getItem('AuthToken'),
        //           userid: sessionStorage.getItem('userid')
        //         }
        //       });
        //
        //       console.log('🧪🧪🧪 [强制验证] signatureApi 响应:', verifyRes);
        //
        //       if (!verifyRes?.data?.signature) {
        //         console.warn('🧪🧪🧪 [强制验证] signatureApi 未返回签名，响应数据:', verifyRes);
        //         return;
        //       }
        //
        //       const verifySignature = verifyRes.data.signature;
        //       console.log('🧪🧪🧪 [强制验证] 获取到签名:', verifySignature);
        //
        //       const wxApi = typeof ww !== 'undefined' ? ww : (typeof wx !== 'undefined' ? wx : null);
        //       if (!wxApi || typeof wxApi.agentConfig !== 'function') {
        //         console.warn('🧪🧪🧪 [强制验证] wxApi 不可用，跳过 agentConfig 验证');
        //         return;
        //       }
        //       wx.agentConfig({
        //         debug: true,
        //         corpid: store.getters.getConfigItem('corpID'),
        //         agentid: process.env.NODE_ENV === 'development' ? '1000036' : '1000035',
        //         nonceStr: 'otob',
        //         timestamp: verifyTimestamp * 1,
        //         signature: verifySignature,
        //         jsApiList: ['chooseMessageFile', 'getLocalFileData'],
        //         success: (res) => {
        //           console.log('🧪🧪🧪 [强制验证] ✅ signatureApi 方式 agentConfig 配置成功!', res);
        //         },
        //         fail: (err) => {
        //           console.error('🧪🧪🧪 [强制验证] ❌ signatureApi 方式 agentConfig 配置失败:', err);
        //         }
        //       });
        //     } catch (verifyErr) {
        //       console.error('🧪🧪🧪 [强制验证] 执行过程出错:', verifyErr);
        //     }
        //   })();
        // }, 0);
        // ==================================================================================

        if (!isWechatEnv) {
          return false;
        }

        // 如果已经配置过，直接返回
        if (wxConfigured) {
          return true;
        }

        // 如果正在配置中，等待配置完成
        if (configPromise) {
          return await configPromise;
        }

        // 开始新的配置
        configPromise = (async () => {
          try {
            const timestamp = Math.round(new Date() / 1000) + '';
            const configData = {
              Url: window.location.href, // 完整 URL,包含 hash(与 related_ot.vue 保持一致)
              Noncestr: 'otob',
              Timestamp: timestamp
            };

            const signatureUrl = store.getters.getConfigItem('signature');
            const { data } = await request.post(signatureUrl, configData);

            const wxApi = typeof ww !== 'undefined' ? ww : wx;

            // 配置并等待 ready
            await new Promise((resolve, reject) => {
              const timeout = setTimeout(() => {
                reject(new Error('微信 SDK 配置超时'));
              }, 10000); // 10秒超时

              wxApi.config({
                beta: true,
                debug: false,
                appId: sessionStorage.getItem('appid') || store.getters.getConfigItem('corpID'),
                timestamp: parseInt(timestamp),
                nonceStr: 'otob',
                signature: data.signature,
                jsApiList: ['chooseImage', 'getLocalImgData', 'agentConfig', 'invoke']
              });

              wxApi.ready(async () => {
                clearTimeout(timeout);
                wxConfigured = true;

                // 如果是企业微信环境,配置 agentConfig 以支持 chooseLocalFile
                const ua = window.navigator.userAgent.toLowerCase();
                const isWxWork = ua.includes('wxwork');

                if (isWxWork) {
                  try {
                    // 使用 signatureApi 获取应用签名（按验证代码的方式）
                    const signatureApiUrl = store.getters.getConfigItem('signatureApi');
                    
                    if (!signatureApiUrl) {
                      console.warn('signatureApi 未配置，跳过 agentConfig 配置');
                      resolve(true);
                      return;
                    }
                    
                    const verifyTimestamp = `${Math.round(new Date() / 1000)}`;
                    const verifyData = {
                      Url: window.location.href,
                      Noncestr: 'otob',
                      Timestamp: verifyTimestamp,
                    };

                    const verifyRes = await request.post(signatureApiUrl, verifyData, {
                      headers: {
                        authToken: sessionStorage.getItem('AuthToken'),
                        userid: sessionStorage.getItem('userid')
                      }
                    });

                    console.log('signatureApi 应用签名响应:', verifyRes);

                    if (!verifyRes?.data?.signature) {
                      console.warn('agentConfig 签名获取失败，跳过 agentConfig 配置');
                      resolve(true);
                      return;
                    }

                    const verifySignature = verifyRes.data.signature;

                    // 配置 agentConfig（完全按验证代码的方式，使用 wx.agentConfig）
                    await new Promise((agentResolve, agentReject) => {
                      wx.agentConfig({
                        debug: true,
                        corpid: store.getters.getConfigItem('corpID'),
                        agentid: process.env.NODE_ENV === 'development' ? '1000036' : '1000035',
                        nonceStr: 'otob',
                        timestamp: verifyTimestamp * 1,
                        signature: verifySignature,
                        jsApiList: ['chooseMessageFile', 'getLocalFileData'],
                        success: (res) => {
                          console.log('agentConfig 配置成功，支持企微文件上传', res);
                          agentConfigured = true;
                          agentResolve(true);
                        },
                        fail: (err) => {
                          console.error('agentConfig 配置失败:', err);
                          console.warn('企微文件上传功能不可用，请检查应用权限配置');
                          agentConfigured = false;
                          agentResolve(false);
                        }
                      });
                    });

                    resolve(true);
                  } catch (err) {
                    console.warn('获取 agentConfig 签名失败，企微文件上传功能不可用:', err);
                    agentConfigured = false;
                    resolve(true);
                  }
                } else {
                  resolve(true);
                }
              });

              wxApi.error((err) => {
                clearTimeout(timeout);
                console.error('微信 JS-SDK 配置失败', err);
                reject(new Error('微信配置错误: ' + (err.errMsg || '未知错误')));
              });
            });

            return true;
          } catch (err) {
            console.error('配置微信 JS-SDK 失败', err);
            throw err;
          } finally {
            configPromise = null; // 重置配置状态
          }
        })();

        return await configPromise;
      };

      // ==================================================================================
      // 🔵🔵🔵 以下是通用逻辑（无论 newChooseImage 是什么值都会执行）🔵🔵🔵
      // ==================================================================================

      field.value.decoratorType = field.value.title ? 'FormItem' : null;
      const valueList = ref([]);
      const filePathList = ref([]);
      const isAiChecking = ref(false); // AI审核中标记，用于禁用上传按钮
      // 🔴 以下两个变量仅 newChooseImage 不为 'none' 时使用
      const uploaderRef = ref(null);
      const shouldTriggerNativeUpload = ref(false);

      // ==================================================================================
      // 🛠️ 工具：深拷贝（切断响应式引用共享，避免翻页时 ArrayTable 复用导致的相互污染）
      // ==================================================================================
      const deepClone = (v) => {
        if (v === null || v === undefined) return v;
        try {
          return JSON.parse(JSON.stringify(v));
        } catch (e) {
          return v;
        }
      };

      // ==================================================================================
      // 🛠️ 工具：获取当前字段路径（用于 async 竞态检查 & Aegis 日志）
      // ==================================================================================
      const getFieldPath = () => {
        try {
          return field.value?.address?.toString?.() || '';
        } catch (e) {
          return '';
        }
      };

      // ==================================================================================
      // 🛠️ Aegis 上报：Upload 相关行为（翻页/字段切换/竞态丢弃/删除等）
      // ==================================================================================
      const reportUploadAegis = (data) => {
        try {
          const aegis = store.state.user?.aegis;
          if (!aegis) return;
          aegis.infoAll({
            msg: JSON.stringify({
              ...data,
              component: 'Upload',
              fieldPath: data.fieldPath ?? getFieldPath(),
              userid: sessionStorage.getItem('userid') || '',
              url: typeof window !== 'undefined' ? window.location.href : '',
              timestamp: new Date().toISOString(),
            }),
            ext1: 'upload-debug',
            trace: `upload-${data.action || 'unknown'}`,
          });
        } catch (e) {
          console.error('[Upload] Aegis 上报失败:', e);
        }
      };

      watch(
        () => props.value,
        (nv, ov) => {
          // 🔴 P0 修复：深拷贝，切断和外部 form.values 数组的引用共享
          // 避免翻页时 ArrayTable 复用组件、内部 push/splice 直接污染外部字段数据
          const cloned = deepClone(nv) || [];
          const prevLen = filePathList.value?.length ?? 0;
          const nextLen = cloned.length;

          filePathList.value = cloned;
          valueList.value = cloned
            .map((item) => item?.response?.FileList?.[0])
            .filter(Boolean);

          // 🔍 定位日志：观察翻页时 watch 的触发情况和引用关系
          reportUploadAegis({
            action: 'watch_props_value',
            sameRef: nv === ov,
            sameRefAsInternal: nv === filePathList.value, // 修复后应恒为 false
            nvLen: Array.isArray(nv) ? nv.length : null,
            ovLen: Array.isArray(ov) ? ov.length : null,
            prevInternalLen: prevLen,
            nextInternalLen: nextLen,
          });
        },
        { deep: true, immediate: true }
      );

      // ==================================================================================
      // 🔴🔴🔴 以下是微信接口相关的辅助函数（仅 newChooseImage 不为 'none' 时调用）🔴🔴🔴
      // ==================================================================================

      // 将 base64 转换为 File 对象
      const base64ToFile = (base64Data, filename) => {
        const arr = base64Data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      };

      // 使用微信接口选择图片
      const chooseImageByWechat = () => {
        return new Promise((resolve, reject) => {
          const wxApi = typeof ww !== 'undefined' ? ww : wx;
          const maxCount = attrs.maxCount || 9;

          wxApi.chooseImage({
            count: maxCount,
            sizeType: ['original', 'compressed'],
            sourceType: field.value.componentProps?.capture === 'camera' ? ['camera'] : ['album', 'camera'],
            success: (res) => {
              const localIds = res.localIds || [];
              resolve(localIds);
            },
            fail: (err) => {
              console.error('微信选择图片失败:', err);
              reject(err);
            },
            cancel: () => {
              reject(new Error('用户取消选择'));
            }
          });
        });
      };

      // 使用企微接口选择文件
      const chooseFileByWechat = () => {
        return new Promise((resolve, reject) => {
          // 检查是否在企微环境
          const ua = window.navigator.userAgent.toLowerCase();
          const isWxWork = ua.includes('wxwork');

          if (!isWxWork) {
            reject(new Error('当前不在企业微信环境中,请在企微工作台打开'));
            return;
          }

          // 检查 agentConfig 是否配置成功
          if (!agentConfigured) {
            reject(new Error('企微应用权限未配置,请联系管理员在企微管理后台开启文件上传权限'));
            return;
          }

          console.log('准备调用企微文件选择接口(chooseMessageFile)');

          // 企微环境优先使用 wx,参考 related_ot.vue
          const wxApi = typeof wx !== 'undefined' ? wx : (typeof window.wx !== 'undefined' ? window.wx : null);

          if (!wxApi) {
            reject(new Error('企业微信 SDK 未加载,请刷新页面重试'));
            return;
          }

          const maxCount = attrs.maxCount || 9;

          try {
            // 使用 wx.invoke 调用企微接口(参考 related_ot.vue 的调用方式)
            // chooseMessageFile - 从聊天记录中选择文件
            wxApi.invoke(
              'chooseMessageFile',
              {
                count: maxCount,
                type: 'file' // 'file' 表示所有文件类型,'image'仅图片,'video'仅视频
              },
              (res) => {
                console.log('企微文件选择结果:', res);

                if (res.err_msg === 'chooseMessageFile:ok') {
                  const tempFiles = res.tempFiles || [];
                  if (tempFiles.length === 0) {
                    reject(new Error('未选择任何文件'));
                    return;
                  }
                  // tempFiles 包含 {name, size, localId, type} 等信息
                  resolve({ type: 'file', tempFiles: tempFiles });
                } else if (res.err_msg === 'chooseMessageFile:cancel') {
                  reject(new Error('用户取消选择'));
                } else {
                  console.error('企微选择文件失败:', res);
                  const errMsg = res.err_msg || '选择文件失败';
                  if (errMsg.includes('permission') || errMsg.includes('nopermission')) {
                    reject(new Error('无文件选择权限,请联系管理员在企微后台配置应用接口权限'));
                  } else if (errMsg.includes('function not exist')) {
                    reject(new Error('当前企业微信版本过低,请升级到最新版本'));
                  } else {
                    reject(new Error(errMsg));
                  }
                }
              }
            );
          } catch (err) {
            console.error('调用企微文件选择接口异常:', err);
            reject(new Error('调用文件选择功能失败,请重试'));
          }
        });
      };

      // 获取图片的本地数据
      const getLocalImageData = (localId) => {
        return new Promise((resolve, reject) => {
          const wxApi = typeof ww !== 'undefined' ? ww : wx;

          wxApi.getLocalImgData({
            localId: localId,
            success: (res) => {
              let localData = res.localData;
              // iOS 系统中获取的数据可能没有前缀
              if (localData && !localData.startsWith('data:image')) {
                localData = 'data:image/jpeg;base64,' + localData;
              }
              resolve(localData);
            },
            fail: (err) => {
              console.error('获取图片数据失败:', err);
              reject(err);
            }
          });
        });
      };

      // 获取企微文件数据（使用 ww.getLocalFileData 接口）
      // 官方文档: https://developer.work.weixin.qq.com/document/path/100765
      // 注意: 文件大小限制 20MB
      const getLocalFileData = (localId) => {
        return new Promise((resolve, reject) => {
          // 优先使用 ww 对象（新版 SDK），其次使用 wx.invoke
          const wwApi = typeof ww !== 'undefined' ? ww : (typeof window.ww !== 'undefined' ? window.ww : null);
          const wxApi = typeof wx !== 'undefined' ? wx : (typeof window.wx !== 'undefined' ? window.wx : null);

          console.log('准备调用 getLocalFileData, localId:', localId);

          // 方式1: 使用新版 ww.getLocalFileData（Promise 方式）
          if (wwApi && typeof wwApi.getLocalFileData === 'function') {
            console.log('使用 ww.getLocalFileData 方式');
            wwApi.getLocalFileData({
              localId: localId
            }).then((res) => {
              console.log('ww.getLocalFileData 成功:', res);
              if (res.errMsg === 'getLocalFileData:ok' || res.localData) {
                resolve(res.localData);
              } else {
                reject(new Error(res.errMsg || '获取文件数据失败'));
              }
            }).catch((err) => {
              console.error('ww.getLocalFileData 失败:', err);
              reject(new Error(err.errMsg || err.message || '获取文件数据失败'));
            });
            return;
          }

          // 方式2: 使用 wx.invoke 调用（旧版兼容方式）
          if (wxApi && typeof wxApi.invoke === 'function') {
            console.log('使用 wx.invoke getLocalFileData 方式');
            wxApi.invoke(
              'getLocalFileData',
              { localId: localId },
              (res) => {
                console.log('wx.invoke getLocalFileData 结果:', res);
                if (res.err_msg === 'getLocalFileData:ok') {
                  resolve(res.localData);
                } else {
                  const errMsg = res.err_msg || '获取文件数据失败';
                  if (errMsg.includes('no permission')) {
                    reject(new Error('无文件读取权限,请联系管理员配置应用权限'));
                  } else if (errMsg.includes('no such file')) {
                    reject(new Error('文件不存在或已过期,请重新选择'));
                  } else if (errMsg.includes('file exceed size limit')) {
                    reject(new Error('文件超过20MB限制,请选择更小的文件'));
                  } else {
                    reject(new Error(errMsg));
                  }
                }
              }
            );
            return;
          }

          reject(new Error('企业微信 SDK 未加载,请刷新页面重试'));
        });
      };

      // 处理微信选择的图片上传
      const handleWechatImageUpload = async (localIds) => {
        const isOpenUpload = store.getters.getConfigItem('isOpenUpload');
        let loadingInstance = null;
        // 🔴 P0 修复：记录发起上传时的字段路径，用于 await 后校验字段是否已切换
        const startPath = getFieldPath();
        reportUploadAegis({ action: 'wechat_image_upload_start', fieldPath: startPath, count: localIds?.length || 0 });

        try {
          if (isOpenUpload === '1') {
            loadingInstance = Toast.loading({
              message: '上传中，请勿离开页面',
              forbidClick: true,
              duration: 0
            });
          }

          for (let i = 0; i < localIds.length; i++) {
            const localId = localIds[i];
            valueList.value.push({ status: 'uploading', message: '上传中...' });

            try {
              const base64Data = await getLocalImageData(localId);

              const fileName = `wechat_image_${Date.now()}_${i}.jpg`;
              const file = base64ToFile(base64Data, fileName);

              // 文件大小上限校验（maxFileSize 单位 MB，未配置时不限制）
              const maxFileSize = Number(attrs.maxFileSize) || 0;
              if (maxFileSize > 0 && file.size > maxFileSize * 1024 * 1024) {
                throw new Error(`图片"${fileName}"大小超过上限，上限为${maxFileSize}MB`);
              }

              const reqData = new FormData();
              reqData.append(field.value.componentProps?.name || 'file', file);
              if (field.value.componentProps?.data) {
                Object.entries(field.value.componentProps?.data).forEach(([key, value]) => {
                  reqData.append(key, value);
                });
              }

              const { data } = await request.post(
                normalizeAction(field.value.componentProps?.action || `/relay/cosfile/index`),
                reqData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(field.value.componentProps?.headers || {}),
                    authToken: sessionStorage.getItem('AuthToken'),
                    userid: sessionStorage.getItem('userid'),
                  },
                }
              );

              if (!data?.FileList?.length) {
                throw new Error('上传失败');
              }

              // 🔴 P0：await 后检查字段路径是否已切换（例如翻页/切行），若切换则丢弃本次结果
              const nowPath = getFieldPath();
              if (nowPath !== startPath) {
                reportUploadAegis({
                  action: 'wechat_image_upload_discard_stale',
                  startPath,
                  nowPath,
                  reason: 'field_path_changed_during_upload',
                });
                valueList.value.pop();
                continue;
              }

              filePathList.value.push(
                ...data?.FileList?.map((item) => ({
                  name: fileName,
                  response: {
                    FileList: [{ ...item, name: fileName }],
                  },
                }))
              );
              valueList.value.splice(-1, 1, ...data?.FileList?.map(({ url }) => ({ url })));
            } catch (e) {
              console.error('上传失败:', e);
              valueList.value.pop();
              throw e;
            }
          }

          // 🔴 P0：最终 emit 前再次校验字段路径 + emit 深拷贝
          const finalPath = getFieldPath();
          if (finalPath !== startPath) {
            reportUploadAegis({
              action: 'wechat_image_upload_skip_emit',
              startPath,
              finalPath,
              reason: 'field_path_changed_before_emit',
            });
            return;
          }
          emit('change', deepClone(filePathList.value));
        } catch (e) {
          Toast.fail(e.message || '上传失败，请稍后再试');
        } finally {
          Toast.clear();
          if (loadingInstance) {
            loadingInstance.clear();
          }
        }
      };

      // 处理企微选择的文件上传（使用 chooseMessageFile + getLocalFileData）
      const handleWechatFileUpload = async (tempFiles) => {
        const isOpenUpload = store.getters.getConfigItem('isOpenUpload');
        let loadingInstance = null;
        let uploadedCount = 0;
        // 🔴 P0 修复：记录发起上传时的字段路径
        const startPath = getFieldPath();
        reportUploadAegis({ action: 'wechat_file_upload_start', fieldPath: startPath, count: tempFiles?.length || 0 });

        try {
          if (isOpenUpload === '1') {
            loadingInstance = Toast.loading({
              message: `上传中(0/${tempFiles.length})，请勿离开页面`,
              forbidClick: true,
              duration: 0
            });
          }

          for (let i = 0; i < tempFiles.length; i++) {
            const tempFile = tempFiles[i];
            const fileName = tempFile.name || `file_${Date.now()}_${i}`;
            const fileSize = tempFile.size || 0;
            const localId = tempFile.localId;

            // 更新进度提示
            if (loadingInstance) {
              loadingInstance.message = `上传中(${i + 1}/${tempFiles.length})，请勿离开页面`;
            }

            valueList.value.push({ status: 'uploading', message: '上传中...' });

            try {
              // 验证 localId
              if (!localId) {
                throw new Error('文件数据异常,请重新选择');
              }

              // 检查文件大小（先校验设计器配置的上限，再校验 getLocalFileData 的 20MB 限制）
              const maxFileSize = Number(attrs.maxFileSize) || 0;
              if (maxFileSize > 0 && fileSize > maxFileSize * 1024 * 1024) {
                throw new Error(`文件"${fileName}"大小超过上限，上限为${maxFileSize}MB`);
              }

              const maxSize = 20 * 1024 * 1024; // 20MB
              if (fileSize > maxSize) {
                throw new Error(`文件"${fileName}"超过20MB限制（企微接口限制）`);
              }

              console.log(`开始获取文件数据: ${fileName}, localId: ${localId}, size: ${fileSize}`);

              // 使用 getLocalFileData 获取文件的 base64 数据
              const base64Data = await getLocalFileData(localId);

              if (!base64Data) {
                throw new Error('获取文件数据失败,请重试');
              }

              console.log(`文件 ${fileName} base64 数据获取成功, 长度: ${base64Data.length}`);

              // 将 base64 转换为 File 对象
              // base64Data 可能已经包含 data:xxx;base64, 前缀，也可能不包含
              let finalBase64 = base64Data;
              if (!base64Data.includes('base64,')) {
                // 根据文件类型添加前缀
                const mimeType = getMimeType(fileName);
                finalBase64 = `data:${mimeType};base64,${base64Data}`;
              }

              const file = base64ToFile(finalBase64, fileName);

              // 上传文件
              const reqData = new FormData();
              reqData.append(field.value.componentProps?.name || 'file', file);
              if (field.value.componentProps?.data) {
                Object.entries(field.value.componentProps?.data).forEach(([key, value]) => {
                  reqData.append(key, value);
                });
              }
              const { data } = await request.post(
                normalizeAction(field.value.componentProps?.action) || `/relay/cosfile/index`,
                reqData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(field.value.componentProps?.headers || {}),
                    authToken: sessionStorage.getItem('AuthToken'),
                    userid: sessionStorage.getItem('userid'),
                  },
                }
              );

              if (!data?.FileList?.length) {
                throw new Error('上传失败');
              }

              // 🔴 P0：await 后检查字段路径是否已切换
              const nowPath = getFieldPath();
              if (nowPath !== startPath) {
                reportUploadAegis({
                  action: 'wechat_file_upload_discard_stale',
                  startPath,
                  nowPath,
                  reason: 'field_path_changed_during_upload',
                });
                valueList.value.pop();
                continue;
              }

              filePathList.value.push(
                ...data?.FileList?.map((item) => ({
                  name: fileName,
                  response: {
                    FileList: [{ ...item, name: fileName }],
                  },
                }))
              );
              valueList.value.splice(-1, 1, ...data?.FileList?.map(({ url }) => ({ url })));
              uploadedCount++;

              console.log(`文件 ${fileName} 上传成功`);

            } catch (e) {
              console.error('文件上传失败:', e);
              valueList.value.pop();
              throw e;
            }
          }

          // 🔴 P0：emit 前再次校验字段路径 + emit 深拷贝
          const finalPath = getFieldPath();
          if (finalPath !== startPath) {
            reportUploadAegis({
              action: 'wechat_file_upload_skip_emit',
              startPath,
              finalPath,
              reason: 'field_path_changed_before_emit',
            });
            return;
          }
          emit('change', deepClone(filePathList.value));

          // 全部成功时的提示
          if (uploadedCount === tempFiles.length && tempFiles.length > 1) {
            Toast.success(`成功上传${uploadedCount}个文件`);
          }
        } catch (e) {
          const errorMsg = e.message || '上传失败，请稍后再试';
          Toast.fail(errorMsg);
        } finally {
          Toast.clear();
          if (loadingInstance) {
            loadingInstance.clear();
          }
        }
      };

      // 根据文件名获取 MIME 类型
      const getMimeType = (fileName) => {
        const ext = fileName.split('.').pop()?.toLowerCase() || '';
        const mimeTypes = {
          // 图片
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          gif: 'image/gif',
          bmp: 'image/bmp',
          webp: 'image/webp',
          svg: 'image/svg+xml',
          // 文档
          pdf: 'application/pdf',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          xls: 'application/vnd.ms-excel',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          txt: 'text/plain',
          // 压缩包
          zip: 'application/zip',
          rar: 'application/x-rar-compressed',
          '7z': 'application/x-7z-compressed',
          // 视频
          mp4: 'video/mp4',
          avi: 'video/x-msvideo',
          mov: 'video/quicktime',
          // 音频
          mp3: 'audio/mpeg',
          wav: 'audio/wav',
          // 默认
          default: 'application/octet-stream'
        };
        return mimeTypes[ext] || mimeTypes.default;
      };

      // ==================================================================================
      // 🔵🔵🔵 newChooseImage = 'none' 时的上传逻辑（原有的 Vant 上传方式）🔵🔵🔵
      // 当 newChooseImage = 'none' 时，直接使用这个函数处理文件上传
      // 当 newChooseImage = 'both'/'chat'/'wework' 且用户选择"浏览器方式"时，也会调用这个函数
      // ==================================================================================
      const afterRead = async (file) => {
        const fileList = file.length ? [...file] : [file];
        const isOpenUpload = store.getters.getConfigItem('isOpenUpload');
        let loadingInstance = null;
        // 🔴 P0 修复：记录发起上传时的字段路径，用于 await 后校验字段是否已切换
        const startPath = getFieldPath();
        reportUploadAegis({ action: 'after_read_start', fieldPath: startPath, count: fileList.length });

        try {
          if (isOpenUpload === '1') {
            loadingInstance = Toast.loading({
              message: '上传中，请勿离开页面',
              forbidClick: true,
              duration: 0
            });
          }

          console.log(attrs, "attrsattrsattrsattrs");
          console.log(fileList, "fileList");
          console.log(file, "file");


          for (file of fileList) {
            valueList.value.push({ status: 'uploading', message: '上传中...' });
            try {
              const reqData = new FormData();
              reqData.append(field.value.componentProps?.name || 'file', file.file);
              if (field.value.componentProps?.data) {
                Object.entries(field.value.componentProps?.data).forEach(([key, value]) => {
                  reqData.append(key, value);
                });
              }
              const { data } = await request.post(normalizeAction(field.value.componentProps?.action) || `/relay/cosfile/index`, reqData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  ...(field.value.componentProps?.headers || {}),
                  authToken: sessionStorage.getItem('AuthToken'),
                  userid: sessionStorage.getItem('userid'),
                },
              });

              console.log(data, "datatttt");

              // 判断attrs.is_ok是否不为空，如果不为空则调用AI Agent进行照片检查
              if (attrs.is_ok && data?.FileList?.length) {
                const imageUrl = data.FileList[0].url;
                const processDefinitionKey = attrs.is_ok; // 将attrs.is_ok的值作为ProcessDefinitionKey

                // 显示AI审核中的提示，并禁用上传按钮
                const loadingToast = Toast.loading({
                  message: 'AI正在审核图片...',
                  forbidClick: true,
                  duration: 0, // 不自动关闭
                });
                isAiChecking.value = true; // 禁用上传按钮

                try {
                  const checkResult = await callAiAgentPhotoCheck(imageUrl, processDefinitionKey);
                  console.log('AI Agent照片检查结果:', checkResult);

                  // 解析AgentResponse中的Result
                  const agentResponse = checkResult?.data?.AgentResponse?.Result;
                  if (agentResponse) {
                    try {
                      const resultObj = JSON.parse(agentResponse);
                      console.log('解析后的Result:', resultObj);

                      // 判断is_ok是否为true（兼容字符串和布尔值）
                      const isOk = resultObj.is_ok === true || resultObj.is_ok === 'true';
                      if (!isOk) {
                        // AI审计失败，弹窗提示
                        Message.error(`AI审计失败：${resultObj.reason || '未知原因'}`);

                        // 只清除当前上传失败的图片占位（此时filePathList还未添加当前文件，无需删除）
                        valueList.value.pop();

                        throw new Error(`AI审计失败：${resultObj.reason || '未知原因'}`);
                      }
                    } catch (parseError) {
                      if (parseError.message.includes('AI审计失败')) {
                        throw parseError;
                      }
                      console.error('解析AgentResponse.Result失败:', parseError);
                    }
                  }
                } catch (checkError) {
                  console.error('AI Agent照片检查失败:', checkError);
                  // 如果是AI审计失败的错误，需要继续抛出
                  if (checkError.message.includes('AI审计失败')) {
                    throw checkError;
                  }
                } finally {
                  // 无论成功还是失败，都关闭加载提示并恢复上传按钮
                  loadingToast.clear();
                  isAiChecking.value = false;
                }
              }

              if (!data?.FileList?.length) {
                throw new Error('上传失败');
              } else {
                // 🔴 P0：await（含请求 + AI 审核）后检查字段路径是否已切换
                const nowPath = getFieldPath();
                if (nowPath !== startPath) {
                  reportUploadAegis({
                    action: 'after_read_discard_stale',
                    startPath,
                    nowPath,
                    reason: 'field_path_changed_during_upload',
                  });
                  valueList.value.pop();
                  continue;
                }

                filePathList.value.push(
                  ...data?.FileList?.map((item) => ({
                    name: file.file.name,
                    response: {
                      FileList: [{ ...item, name: file.file.name }],
                    },
                  }))
                );
                valueList.value.splice(-1, 1, ...data?.FileList?.map(({ url }) => ({ url })));
              }
            } catch (e) {
              console.error('上传失败:', e);
              valueList.value.pop();
              throw e;
            }
          }
          // 🔴 P0：emit 前再次校验字段路径 + emit 深拷贝
          const finalPath = getFieldPath();
          if (finalPath !== startPath) {
            reportUploadAegis({
              action: 'after_read_skip_emit',
              startPath,
              finalPath,
              reason: 'field_path_changed_before_emit',
            });
            return;
          }
          emit('change', deepClone(filePathList.value));
        } catch (e) {
          Toast.fail('上传失败，请稍后再试');
        } finally {
          // 结束全局loading
          Toast.clear();
          if (loadingInstance) {
            loadingInstance.clear();
          }
        }
      };
      // ==================================================================================
      // ==================================================================================

      // ==================================================================================
      // 🔵🔵🔵 newChooseImage = 'none' 时：不拦截点击事件，直接使用 Vant 原生上传 🔵🔵🔵
      // ==================================================================================
      const beforeDelete = (file, detail) => {
        // 禁用态（字段禁用或 AI 审核中）禁止删除已上传文件
        if (isAiChecking.value || field.value.disabled) {
          Toast.fail('当前状态不可删除');
          return false;
        }
        // 🟡 P1 修复：优先使用 Vant 提供的 detail.index，避免不同行使用同一 url 时 findIndex 命中错误项
        let index = typeof detail?.index === 'number' ? detail.index : -1;
        if (index < 0) {
          index = valueList.value.findIndex((item) => item.url === file?.url);
        }
        if (index < 0) {
          reportUploadAegis({ action: 'before_delete_index_not_found', url: file?.url });
          return false;
        }
        reportUploadAegis({
          action: 'before_delete',
          index,
          url: file?.url,
          totalBefore: valueList.value.length,
        });
        valueList.value.splice(index, 1);
        filePathList.value.splice(index, 1);
        // 🔴 P0：emit 深拷贝，切断引用共享
        emit('change', deepClone(filePathList.value));
      };

      const oversize = () => {
        const maxFileSize = Number(attrs.maxFileSize) || 0;
        return Toast.fail(
          maxFileSize > 0
            ? `上传文件大小不能超过${maxFileSize}MB`
            : '上传文件大小不能超过300M'
        );
      };

      // ==================================================================================
      // OCR Aegis 上报辅助函数
      // ==================================================================================
      const reportOcrAegis = (data) => {
        try {
          const aegis = store.state.user?.aegis;
          if (!aegis) return;
          aegis.infoAll({
            msg: JSON.stringify({
              ...data,
              component: 'Upload',
              userid: sessionStorage.getItem('userid') || '',
              timestamp: new Date().toISOString(),
            }),
            ext1: 'upload-ocr',
            trace: `ocr-${data.action}`,
          });
        } catch (e) {
          console.error('[Upload] Aegis OCR上报失败:', e);
        }
      };

      // ==================================================================================
      // OCR 文字提取相关函数
      // ==================================================================================

      // 在 ImagePreview 界面注入"提取文字"按钮
      const injectOcrButton = (previewInstance, imageUrls, currentIndex) => {
        const previewEl = document.querySelector('.van-image-preview');
        if (!previewEl) return;

        // 避免重复注入
        if (previewEl.querySelector('.ocr-extract-btn')) return;

        const btn = document.createElement('div');
        btn.className = 'ocr-extract-btn';
        btn.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7V5C3 3.9 3.9 3 5 3H7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M17 3H19C20.1 3 21 3.9 21 5V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M21 17V19C21 20.1 20.1 21 19 21H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M7 21H5C3.9 21 3 20.1 3 19V17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="7" y1="8.5" x2="17" y2="8.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            <line x1="7" y1="12" x2="15" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            <line x1="7" y1="15.5" x2="12" y2="15.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
          <span>提取文字</span>
        `;

        btn.style.cssText = `
          position: fixed;
          right: 16px;
          bottom: 60px;
          z-index: 2100;
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          background: rgba(25, 137, 250, 0.9);
          color: #fff;
          border-radius: 24px;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 2px 12px rgba(25, 137, 250, 0.4);
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
          user-select: none;
          transition: all 0.2s;
        `;

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          // 获取当前预览的图片index
          let idx = currentIndex;
          const swiperItems = previewEl.querySelectorAll('.van-image-preview__index');
          if (swiperItems.length > 0) {
            const indexText = swiperItems[0].textContent;
            const match = indexText.match(/(\d+)/);
            if (match) idx = parseInt(match[1]) - 1;
          }
          const targetUrl = imageUrls[idx] || imageUrls[currentIndex];

          // 关闭预览
          if (previewInstance && previewInstance.close) {
            previewInstance.close();
          }

          // Aegis 上报：点击提取文字按钮
          reportOcrAegis({ action: 'ocr_extract_click', imageUrl: targetUrl });

          // 打开 OCR 弹窗
          showOcrDialog(targetUrl);
        });

        btn.addEventListener('touchstart', () => {
          btn.style.transform = 'scale(0.95)';
          btn.style.opacity = '0.8';
        });
        btn.addEventListener('touchend', () => {
          btn.style.transform = 'scale(1)';
          btn.style.opacity = '1';
        });

        previewEl.appendChild(btn);
      };

      // 显示 OCR 识别结果弹窗（动态创建 Vue 实例）
      const showOcrDialog = (imageUrl) => {
        const ocrVm = new Vue({
          data() {
            return {
              show: true,
              status: 'scanning', // scanning | completed
              rawText: '',
              previewImage: imageUrl,
            };
          },
          async created() {
            try {
              // Aegis 上报：OCR 识别开始
              reportOcrAegis({ action: 'ocr_recognition_start_upload', imageUrl: imageUrl });

              const response = await ocrImage(imageUrl, '', {}, store.getters.getConfigItem('ocrFlowKey') || '');

              if (response?.data?.data?.AgentResponse?.Result) {
                this.rawText = response.data.data.AgentResponse.Result;
                this.status = 'completed';
                // Aegis 上报：OCR 识别成功
                reportOcrAegis({ action: 'ocr_recognition_success', imageUrl: imageUrl, textLength: this.rawText.length });
              } else {
                Toast('OCR识别失败，请确保图片中包含文字信息');
                console.error('OCR识别失败:', response?.data?.data?.AgentResponse);
                // Aegis 上报：OCR 识别失败
                reportOcrAegis({ action: 'ocr_recognition_failed', imageUrl: imageUrl, reason: 'empty_result' });
                this.close();
              }
            } catch (error) {
              console.error('OCR识别失败:', error);
              Toast('OCR识别失败，请确保图片中包含文字信息');
              // Aegis 上报：OCR 识别异常
              reportOcrAegis({ action: 'ocr_recognition_error', imageUrl: imageUrl, error: error.message });
              this.close();
            }
          },
          methods: {
            close() {
              // Aegis 上报：OCR 弹窗关闭
              reportOcrAegis({ action: 'ocr_dialog_closed' });
              this.show = false;
              this.$nextTick(() => {
                this.$destroy();
                const parentNode = this.$el.parentNode;
                if (parentNode) {
                  parentNode.removeChild(this.$el);
                }
              });
            },
            previewOcrImage() {
              // Aegis 上报：预览 OCR 图片
              reportOcrAegis({ action: 'ocr_image_preview', imageUrl: this.previewImage });
              ImagePreview({
                images: [this.previewImage],
                startPosition: 0,
                closeable: true,
              });
            },
            async copyOcrText() {
              try {
                if (navigator.clipboard && window.isSecureContext) {
                  await navigator.clipboard.writeText(this.rawText);
                } else {
                  const textarea = document.createElement('textarea');
                  textarea.value = this.rawText;
                  textarea.style.position = 'fixed';
                  textarea.style.opacity = '0';
                  document.body.appendChild(textarea);
                  textarea.select();
                  document.execCommand('copy');
                  document.body.removeChild(textarea);
                }
                Toast.success('复制成功');
                // Aegis 上报：复制 OCR 文本成功
                reportOcrAegis({ action: 'ocr_text_copy_success', textLength: this.rawText.length });
              } catch (error) {
                console.error('复制失败:', error);
                Toast.fail('复制失败，请手动复制');
                // Aegis 上报：复制 OCR 文本失败
                reportOcrAegis({ action: 'ocr_text_copy_failed', error: error.message });
              }
            },
            // 处理用户手动选择并复制OCR文本
            handleManualCopy(event) {
              try {
                // 获取用户选中的文本
                const selection = window.getSelection();
                const selectedText = selection ? selection.toString() : '';
                
                if (selectedText) {
                  // Aegis 上报：用户手动选择并复制 OCR 文本
                  reportOcrAegis({ 
                    action: 'ocr_text_manual_copy', 
                    textLength: selectedText.length,
                    totalLength: this.rawText.length,
                    isPartial: selectedText.length < this.rawText.length
                  });
                }
              } catch (e) {
                console.error('[Upload] 处理手动复制事件失败:', e);
              }
            },
          },
          render(h) {
            const scanningContent = h('div', { class: 'ocr-scanning' }, [
              h('div', { class: 'ocr-scanning__header' }, [
                h('h3', '正在识别图片'),
                h('p', { class: 'ocr-scanning__tip' }, '请稍候...'),
              ]),
              h('div', { class: 'ocr-scanning__image-container' }, [
                h('img', { class: 'ocr-scanning__image', attrs: { src: this.previewImage, alt: '识别中的图片' } }),
                h('div', { class: 'ocr-scan-line' }),
                h('div', { class: 'ocr-scan-overlay' }),
              ]),
            ]);

            const completedContent = h('div', { class: 'ocr-result' }, [
              h('div', { class: 'ocr-result__header' }, [
                h('h3', '识别结果'),
                h('p', { class: 'ocr-result__tip' }, '完整识别的文本，可手动复制'),
              ]),
              h('div', { class: 'ocr-result__scrollable' }, [
                h('div', { class: 'ocr-result__image-preview' }, [
                  h('img', {
                    class: 'ocr-result__image',
                    attrs: { src: this.previewImage, alt: '原图片' },
                    on: { click: this.previewOcrImage },
                  }),
                ]),
                h('div', { class: 'ocr-manual-text' }, [
                  h('div', { 
                    class: 'ocr-manual-text__content',
                    on: { copy: this.handleManualCopy }
                  }, this.rawText),
                  h('p', { class: 'ocr-manual-hint' }, '以上为原始识别结果，支持手动选中并复制'),
                  h('van-button', {
                    class: 'ocr-copy-btn',
                    props: { type: 'primary', size: 'small', plain: true, icon: 'copy-o' },
                    on: { click: this.copyOcrText },
                  }, '复制全部'),
                ]),
              ]),
              h('div', { class: 'ocr-result__footer' }, [
                h('van-button', { props: { block: true, type: 'default' }, on: { click: this.close } }, '关闭'),
              ]),
            ]);

            return h('van-popup', {
              props: {
                value: this.show,
                position: 'bottom',
                closeable: true,
                getContainer: 'body',
              },
              style: { maxHeight: '80%' },
              on: {
                input: (val) => { if (!val) this.close(); },
              },
            }, [
              h('div', { class: 'ocr-dialog' }, [
                this.status === 'scanning' ? scanningContent : completedContent,
              ]),
            ]);
          },
        });

        const mountNode = document.createElement('div');
        document.body.appendChild(mountNode);
        ocrVm.$mount(mountNode);
      };

      // ==================================================================================
      // 🔴🔴🔴 以下是 newChooseImage = TRUE 时的逻辑（微信接口相关） 🔴🔴🔴
      // 🔵🔵🔵 newChooseImage = FALSE 时，以下代码都不会执行 🔵🔵🔵
      // ==================================================================================

      // 显示选择上传方式的对话框（根据 newChooseImage 动态显示选项）
      const showUploadMethodDialog = () => {
        return new Promise((resolve, reject) => {
          // 根据 newChooseImage 配置动态生成选项
          // 浏览器上传选项始终存在
          const actions = [
            { name: '使用浏览器拍照/上传', value: 'browser' }
          ];

          // 根据配置添加企微相关选项
          if (newChooseImage === 'both' || newChooseImage === 'wework') {
            actions.unshift({ name: '使用微信拍照/选图', value: 'wechat' });
          }
          
          if (newChooseImage === 'both' || newChooseImage === 'chat') {
            actions.splice(actions.findIndex(a => a.value === 'browser'), 0, 
              { name: '从会话选择文件上传', value: 'wechat-file' });
          }

          const actionSheetVm = new Vue({
            data() {
              return {
                show: true,
                actions: actions
              };
            },
            methods: {
              onSelect(item) {
                this.show = false;
                this.$nextTick(() => {
                  this.$destroy();
                  this.$el.parentNode?.removeChild(this.$el);
                  resolve(item.value);
                });
              },
              onCancel() {
                this.show = false;
                this.$nextTick(() => {
                  this.$destroy();
                  this.$el.parentNode?.removeChild(this.$el);
                  reject(new Error('用户取消选择'));
                });
              }
            },
            render(h) {
              return h('van-action-sheet', {
                props: {
                  value: this.show,
                  actions: this.actions,
                  cancelText: '取消'
                },
                on: {
                  input: (val) => {
                    if (!val) this.onCancel();
                  },
                  select: this.onSelect,
                  cancel: this.onCancel
                }
              });
            }
          });

          const mountNode = document.createElement('div');
          document.body.appendChild(mountNode);
          actionSheetVm.$mount(mountNode);
        });
      };

      // 辅助函数：触发浏览器原生上传（作为兜底方案）
      const triggerBrowserUpload = async (event) => {
        shouldTriggerNativeUpload.value = true;
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const uploaderElement = event?.target?.closest?.('.van-uploader') || document.querySelector('.van-uploader');
        if (uploaderElement) {
          const input = uploaderElement.querySelector('.van-uploader__input');
          if (input) {
            input.click();
          }
        }
        
        setTimeout(() => {
          shouldTriggerNativeUpload.value = false;
        }, 1000);
      };

      // 处理点击上传按钮（仅微信环境使用）
      const handleClickUpload = async (event) => {
        try {
          // 根据 newChooseImage 的值决定显示哪些选项
          // 浏览器上传选项始终存在，企微相关选项根据配置显示
          const uploadMethod = await showUploadMethodDialog();

          if (uploadMethod === 'browser') {
            // 使用浏览器原生方式，设置标记让后续点击事件通过
            shouldTriggerNativeUpload.value = true;

            // 延迟触发，确保标记已设置
            await new Promise(resolve => setTimeout(resolve, 100));

            // 查找 input 元素并触发点击
            const uploaderElement = event?.target?.closest?.('.van-uploader') || document.querySelector('.van-uploader');

            if (uploaderElement) {
              const input = uploaderElement.querySelector('.van-uploader__input');
              if (input) {
                input.click();
              } else {
                Toast.fail('无法打开文件选择器');
              }
            } else {
              Toast.fail('无法打开文件选择器');
            }

            // 重置标记
            setTimeout(() => {
              shouldTriggerNativeUpload.value = false;
            }, 1000);

            return;
          }

          // 使用微信/企微接口
          const configToast = Toast.loading({
            message: '初始化中...',
            forbidClick: true,
            duration: 0
          });

          try {
            // 确保微信 SDK 已配置
            const configured = await ensureWechatConfig();

            // 关闭配置提示
            configToast.clear();

            if (!configured) {
              // SDK 配置失败时，提供浏览器上传作为兜底选项
              Toast.fail('微信环境初始化失败，正在切换到浏览器上传模式');
              await triggerBrowserUpload(event);
              return;
            }

            // 等待一小段时间确保配置生效
            await new Promise(resolve => setTimeout(resolve, 300));

            if (uploadMethod === 'wechat-file') {
              // 使用企微文件选择
              try {
                const result = await chooseFileByWechat();
                if (result && result.tempFiles && result.tempFiles.length > 0) {
                  await handleWechatFileUpload(result.tempFiles);
                } else {
                  Toast.fail('未选择任何文件');
                }
              } catch (fileErr) {
                // 如果是"用户取消选择",不显示错误
                if (fileErr.message !== '用户取消选择') {
                  // 提供浏览器上传作为兜底
                  Toast.fail(`${fileErr.message || '文件选择失败'}，将切换到浏览器上传模式`);
                  await triggerBrowserUpload(event);
                }
              }
            } else {
              // 使用微信图片选择
              try {
                const localIds = await chooseImageByWechat();
                if (localIds && localIds.length > 0) {
                  await handleWechatImageUpload(localIds);
                }
              } catch (imgErr) {
                // 如果是"用户取消选择",不显示错误
                if (imgErr.message !== '用户取消选择') {
                  // 提供浏览器上传作为兜底
                  Toast.fail(`${imgErr.message || '图片选择失败'}，将切换到浏览器上传模式`);
                  await triggerBrowserUpload(event);
                }
              }
            }
          } catch (err) {
            configToast.clear();
            if (err.message !== '用户取消选择') {
              Toast.fail(err.message || '选择文件失败');
              // 提供浏览器上传作为兜底
              await triggerBrowserUpload(event);
            }
          }
        } catch (err) {
          // 用户取消选择方式（不显示错误）
          console.log('用户取消上传', err);
        }
      };

      // ==================================================================================
      // ✅✅✅ 关键判断：决定是使用新逻辑还是旧逻辑 ✅✅✅
      // newChooseImage = 'both'/'chat'/'wework' 且 isWechatEnv = true  → shouldUseWechatApi = true  → 拦截点击
      // newChooseImage = 'none' 或 isWechatEnv = false → shouldUseWechatApi = false → 不拦截，直接使用 Vant 原生上传
      // ==================================================================================
      const shouldUseWechatApi = newChooseImage !== 'none' && isWechatEnv;

      return () => {
        const moveUploadGrayscale = store.getters.getConfigItem('moveUploadGrayscale');
        const newUploadBlacklist = store.getters.getConfigItem('newUploadBlacklist');
        const formValue = form.value?.values?.$context?.ProcessDefinitionKey;
        const isUploadMove = moveUploadGrayscale.includes(formValue);
        const createTime = form.value?.values?.$context?.CreateTime;

        // createTime 还没拿到时不渲染，等数据就绪后再继续
        if (!createTime) return null;
        console.log(createTime, "createTime");


        const newTime = '2026-03-24 10:30:00';
        const useNewUpload = new Date(createTime) >= new Date(newTime);
        console.log(useNewUpload, "useNewUpload");
        console.log(isUploadMove, "useNewUploadisUploadMove");


        const uploaderProps = {
          attrs: {
            // 移除这里的硬编码 accept,使用上面 setup 中设置的 attrs.accept
            ...attrs,
            maxCount: attrs.maxCount ?? undefined,
            fileList: valueList.value,
            // 文件大小上限：设计器配置（单位 MB）优先，未配置时沿用默认的 300MB
            maxSize: attrs.maxFileSize > 0 ? attrs.maxFileSize * 1024 * 1024 : 300000 * 1024,
            // ✅ 始终保持 afterRead 回调（无论 newChooseImage 是 true 还是 false）
            afterRead: afterRead,
            beforeDelete,
            'result-type': 'file',
            // AI审核中时禁用上传按钮，同时支持字段禁用状态
            disabled: isAiChecking.value || field.value.disabled || false,
            // 禁用态（字段禁用或 AI 审核中）下隐藏删除按钮，避免仍可删除已上传文件
            deletable: !(isAiChecking.value || field.value.disabled),
            // 🔵 mobileSmall 有值时使用指定尺寸（如 '30' → '30px'），否则使用默认大小（80px）
            'preview-size': mobileSmall ? `${mobileSmall}px` : '80px',
          },
          on: {
            ...listeners,
            oversize,
            'click-preview': (file, detail) => {
              const fileType = file?.url?.split?.('.');
              const imageExts = ['jpg', 'jpeg', 'png', 'svg', 'bmp', 'gif', 'webp'];
              const isImage = Array.isArray(fileType) &&
                imageExts.some((item) => fileType?.[fileType.length - 1]?.toLowerCase?.().endsWith(item));

              if (!isImage) {
                // 优先使用企微原生 previewFile（支持所有文件类型）
                const isWxEnv = typeof window !== 'undefined' &&
                  (window.navigator.userAgent.toLowerCase().includes('micromessenger') ||
                   window.navigator.userAgent.toLowerCase().includes('wxwork'));
                if (isWxEnv && wxConfigured) {
                  const wxApi = typeof ww !== 'undefined' ? ww : wx;
                  // 通过 HEAD 请求获取文件大小（previewFile 必填）
                  fetch(file.url, { method: 'HEAD' }).then(resp => {
                    const size = parseInt(resp.headers.get('content-length') || '0', 10);
                    wxApi.ready(() => {
                      wxApi.invoke('previewFile', {
                        url: file.url,
                        name: file.name || '',
                        size: size,
                      }, (res) => {
                        if (!res || !res.err_msg || res.err_msg.indexOf('ok') < 0) {
                          // 企微预览失败，回退到弹窗
                          previewFileInPopup(file.url, file.name || '');
                        }
                      });
                    });
                  }).catch(() => {
                    previewFileInPopup(file.url, file.name || '');
                  });
                  return;
                }
                // 非企微环境：弹窗预览非图片文件
                previewFileInPopup(file.url, file.name || '');
                return;
              }

              // 图片类型：使用自定义 ImagePreview，附带"提取文字"按钮
              const allImageUrls = valueList.value
                .filter(f => {
                  const ext = f?.url?.split?.('.');
                  return Array.isArray(ext) && imageExts.some(e => ext[ext.length - 1]?.toLowerCase?.().endsWith(e));
                })
                .map(f => f.url);

              const currentIdx = allImageUrls.indexOf(file.url);
              const previewInstance = ImagePreview({
                images: allImageUrls.length > 0 ? allImageUrls : [file.url],
                startPosition: currentIdx >= 0 ? currentIdx : 0,
                closeable: true,
              });

              // 注入"提取文字"按钮
              setTimeout(() => {
                injectOcrButton(previewInstance, allImageUrls.length > 0 ? allImageUrls : [file.url], currentIdx >= 0 ? currentIdx : 0);
              }, 300);
            },
            // ==================================================================================
            // 🔴🔴🔴 newChooseImage 不为 'none' 时：拦截点击事件 🔴🔴🔴
            // 🔵🔵🔵 newChooseImage = 'none' 时：不拦截，直接使用 Vant 原生流程 🔵🔵🔵
            // ==================================================================================
            'click-upload': (e) => {
              // ✅ 检查禁用状态：如果禁用则阻止事件
              const isDisabled = isAiChecking.value || field.value.disabled;
              if (isDisabled) {
                e.stopPropagation();
                e.preventDefault();
                return; // 禁用状态下不执行任何操作
              }

              // 🔴 newChooseImage 不为 'none' 时走这里
              if (shouldUseWechatApi && !shouldTriggerNativeUpload.value) {
                e.stopPropagation();
                e.preventDefault();
                handleClickUpload(e);  // 👈 显示选择对话框
              }
              // 🔴 选择"浏览器方式"后，标记为 true，让原生事件通过
              // 🔵 newChooseImage = 'none' 时什么都不做，让 Vant 组件的默认行为执行
            },
            click(e) {
              emit('emit', e);
            },
          },
        };
        const originalAction = field.value.componentProps?.action || '';
        const action = normalizeAction(originalAction);
        console.log(originalAction, "原始 action");
        console.log(action, "替换后的 action");

        // 构造 NewUpload 需要的 props（统一处理，避免重复代码）
        const buildNewUploadProps = () => ({
          ...uploaderProps,
          props: {
            ...(uploaderProps.props || {}),
            newChooseImage,
            uploadName: field.value.componentProps?.name || '',
            uploadAction: action,
            uploadHeaders: field.value.componentProps?.headers || {},
            uploadData: field.value.componentProps?.data || {},
            expiration: field.value.componentProps?.expiration,
            multiple: field.value.componentProps?.multiple || false,
            // 上传时全屏遮罩（默认 false，由设计器开关控制，开启后上传期间不可点击提交按钮）
            blockingLoading: field.value.componentProps?.blockingLoading ?? false,
            // 弹窗预览非图片文件（默认 true，可通过 componentProps.usePopupPreview 覆盖）
usePopupPreview: field.value.componentProps?.usePopupPreview ?? false,
          },
        });

        if (action === '/relay/cosfile/index') {
          // 旧通道：保留原有灰度判断逻辑
          const useNew = (useNewUpload && isUploadMove && !newUploadBlacklist.includes(sessionStorage.getItem('userid')));
          console.log(useNew, "newsssssss");
          if (useNew) {
            return h(NewUpload, buildNewUploadProps(), slots);
          }
          return h(VanUploader, uploaderProps, slots);
        } else if (action === '/file-center/tus/relay/cosfile/') {
          // 新通道：强制使用 NewUpload
          return h(NewUpload, buildNewUploadProps(), slots);
        } else {
          // 其他情况：使用原生 VanUploader
          return h(VanUploader, uploaderProps, slots);
        }
      };
    },
  })
);

// 解析文件可展示的真实 url（与 newUpload.vue / newUpload.js 中 resolveFileUrl 逻辑保持一致）
// 1. item.url 存在且不是本地地址（blob:/data:）时优先使用（兼容外部替换的水印链接等场景）
// 2. item.url 为本地地址（blob:/data:，刷新后失效）或不存在时，回退到 response.FileList[0].url（真实图床地址）
function resolveFileUrl(item) {
  if (!item) return '';
  const itemUrl = item.url || '';
  if (itemUrl && !itemUrl.startsWith('blob:') && !itemUrl.startsWith('data:')) {
    return itemUrl;
  }
  return (item.response && item.response.FileList && item.response.FileList[0] && item.response.FileList[0].url) || '';
}

// 图片后缀判断（与 vant 的 isImageUrl 保持一致）
const IMAGE_EXT_RE = /\.(jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg)(\?.*)?$/i;

// 自定义 Uploader 只读预览组件
// 背景：PreviewText.Uploader（@formily/vant 库）直接把 Formily 原始 value 作为 fileList 传给 van-uploader，
// 历史 antd 格式数据中 item.url 是会话级的 blob 地址，vant 将其判为非图片（无后缀）且数据没有 file 字段，
// 导致只读态直接显示 blob url 文本而非缩略图。
// 解决：渲染前解析出真实 url（response.FileList[0].url），并设置 isImage，保证只读态正常显示缩略图。
const UploaderPreviewText = observer(
  defineComponent({
    name: 'FUploaderPreviewText',
    setup(props, { attrs, slots, listeners }) {
      return () => {
        // isBlob 未开启：直接复用库默认只读预览，保持与原来完全一致
        if (store.getters.getConfigItem('isBlob') !== '1') {
          return h(PreviewText.Uploader, { ...attrs }, slots);
        }
        const value = attrs.value || [];
        if (!value || !value.length) {
          // 空值：复用 PreviewText.Uploader 的占位符行为，保持与原来一致
          return h(PreviewText.Uploader, { ...attrs }, slots);
        }
        const fileList = value.map((item) => {
          const url = resolveFileUrl(item);
          return {
            ...item,
            url,
            isImage: IMAGE_EXT_RE.test(item.name || url),
          };
        });
        return h(
          VanUploader,
          {
            class: 'formily-uploader-preview',
            style: attrs.style,
            attrs: {
              ...attrs,
              deletable: false,
              showUpload: false,
              fileList,
              disabled: false,
            },
            on: listeners,
          },
          slots
        );
      };
    },
  })
);

export const Uploader = connect(
  BaseUploader,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(UploaderPreviewText)
);

export default Uploader;